<template>
  <div>
    <BackButton link="/account/team" text="Back to Team" />
    <DashboardHeader
      heading="Invite team member"
      paragraph="Invite team member to join PartnerPage"
    />
    <form @submit.prevent="sendInvites(invites)">
      <div class="grid grid--rev">
        <div class="grid__cell col5-of-12--large-up"></div>
        <div class="grid__cell col7-of-12--large-up">
          <Invitation
            :company-enabled="false"
            v-for="(invite, i) in inviteCount"
            :key="i"
            :index="i"
            @invite-change="handleInviteChange"
          />
          <div class="flex justify-end">
            <Button v-on:button-click="addInvite" bType="secondary">
              Add another member
            </Button>
            <Button type="submit" bMargin="left">
              Send invitations
            </Button>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import BackButton from '@/components/BackButton';
import Button from '@/components/DesignSystem/Button';
import DashboardHeader from '@/components/Dashboard/DashboardHeader';
import Invitation from '@/components/Dashboard/Invitation';
import { mapActions } from 'vuex';

export default {
  name: 'TeamInvite',
  components: {
    BackButton,
    DashboardHeader,
    Invitation,
    Button,
  },
  data() {
    return {
      inviteCount: 1,
      invites: [{}],
    };
  },
  methods: {
    handleInviteChange(payload) {
      this.invites[payload.key] = payload.data;
    },
    addInvite() {
      this.inviteCount++;
    },
    ...mapActions({
      sendInvites: 'userAccount/sendInvites',
    }),
  },
};
</script>
